import { render, staticRenderFns } from "./notice_item_dialog.vue?vue&type=template&id=6c85a421"
import script from "./notice_item_dialog.vue?vue&type=script&lang=js"
export * from "./notice_item_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports